import * as React from 'react';
import { FocusContext } from './FocusContext';
/** Hook to access the [[FocusContext]]. */
export function useFocus() {
    var context = React.useContext(FocusContext);
    if (!context) {
        throw new Error('useFocus must be used within a FocusProvider');
    }
    return context;
}
//# sourceMappingURL=useFocus.js.map